<template>
  <div class="min-w-10 min-h-10 bg-red-700 text-white absolute right-5 top-5 rounded-lg">
    <div v-if="open">
      <div class="p-2">
        <ul>
          <li class="cursor-pointer mb-1" @click="fillQuestionnaire">Fill Questionnaire</li>
          <li class="cursor-pointer mb-1" @click="open = false">Close</li>
        </ul>
      </div>
    </div>
    <div v-else class="px-5 py-2" @click="open = true">Dev Options</div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'

const open = ref(false)
const fillQuestionnaire = () => {
  const formModel = useLocalStorage('questionnaireModel', {})
  formModel.value = {
    basisangaben: {},
    neueinstellung: { isNewHire: 'yes', employmentContractStartDate: '2023-01-17' },
    befristung: { isFixedTermContract: false },
    position: { employmentPosition: 'DSsadfasd' },
    stellenbeschreibung: { withJobDescription: true, workingHours: '40', workDays: 5 },
    gehalt: { paymentType: 'basic-wage', vacationDays: '30', monthlyBasicWage: '3200' },
    arbeitgeber: {
      employerName: 'CMPP GmbH',
      employerAddress: 'Bahrenfelder Str. 157',
      employerZip: '22765',
      employerCity: 'Hamburg',
      employerCountry: 'de',
    },
    mitarbeiter: {
      employeeFirstName: 'Kristoffer Jonas',
      employeeLastName: 'Klauß',
      employeeAddress: 'Beim Grünen Jäger 14',
      employeeZip: '20359',
      employeeCity: 'Hamburg',
      employeeCountry: 'ug',
    },
  }
}
</script>
